import { getAdminAxiosInstance } from "../../../api/Admin";

export const updatePrivacySettings = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/app-settings/store`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
